export const OwnCheckoutIntegrations = [
  'vtex',
  'magento2',
  'plazaH',
  'cencosud_paris',
  'shopify',
  'carso',
  'fenicio',
  'privalia_home',
  'linx',
  'natura',
  'kiehls',
  'lancome',
  'walmart',
]

export const OwnWindowIntegrations = [
  'jumbo',
  'mercado_pago',
  'shopify',
  'carso',
  'stripe',
  'essen_ecommerce',
  'linx',
  'tienda_nube',
]

export const OwnFormCheckout = ['tienda_nube', 'to_agree']

export const HasLogoUIIntegrations = ['mercado_pago', 'paypal', 'stripe']
